import { supabase } from '../lib/supabase';

const TABLE_NAME = 'client_sources';

// Get all client sources
export const getClientSources = async () => {
  try {
    const { data, error } = await supabase
      .from(TABLE_NAME)
      .select('*')
      .order('name', { ascending: true });

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error fetching client sources:', error);
    throw error;
  }
};

// Create a new client source
export const createClientSource = async (sourceData) => {
  try {
    const { data, error } = await supabase
      .from(TABLE_NAME)
      .insert([sourceData])
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error creating client source:', error);
    throw error;
  }
};

// Update a client source
export const updateClientSource = async (id, sourceData) => {
  try {
    const { data, error } = await supabase
      .from(TABLE_NAME)
      .update(sourceData)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error updating client source:', error);
    throw error;
  }
};

// Delete a client source
export const deleteClientSource = async (id) => {
  try {
    const { error } = await supabase
      .from(TABLE_NAME)
      .delete()
      .eq('id', id);

    if (error) throw error;
  } catch (error) {
    console.error('Error deleting client source:', error);
    throw error;
  }
};
